import { render, staticRenderFns } from "./usuarios.vue?vue&type=template&id=a1b53454&scoped=true&"
import script from "./usuarios.vue?vue&type=script&lang=js&"
export * from "./usuarios.vue?vue&type=script&lang=js&"
import style0 from "./usuarios.vue?vue&type=style&index=0&id=a1b53454&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b53454",
  null
  
)

export default component.exports